import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useDropdown } from '~/eds/src/components/hooks/useDropdown';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Text } from '~/eds/src/components/Text/Text';

import { Operator } from '../operator/Operator';

type Props = {
  value: 'and' | 'or';
  onChange: (value: 'and' | 'or') => void;
};
export const OperatorSelect = ({ value, onChange }: Props) => {
  const [wrap, _, hide, toggle] = useDropdown({
    children: (
      <Layout p={2} direction="column">
        <Layout
          p={1}
          onClick={() => {
            hide();
            onChange('and');
          }}
        >
          <Text>
            <FormattedMessage
              id="OperatorSelect.andLabel"
              defaultMessage="AND"
              description="Label for AND operator in operator select dropdown"
            />
          </Text>
        </Layout>
        <Layout
          p={1}
          onClick={() => {
            hide();
            onChange('or');
          }}
        >
          <Text>
            <FormattedMessage
              id="OperatorSelect.orLabel"
              defaultMessage="OR"
              description="Label for OR operator in operator select dropdown"
            />
          </Text>
        </Layout>
      </Layout>
    ),
  });

  return wrap(
    <Layout onClick={toggle}>
      <Operator value={value} icon="chevron-down" />
    </Layout>,
  );
};
